import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment.prod';
import { response } from './interface';

@Injectable({
  providedIn: 'root'
})
export class TaskService {

  constructor(
    private http: HttpClient
  ) { }

  getTasks(modelId, modelName, status){
    let params : HttpParams = new HttpParams().set("modelId", modelId).set("modelName", modelName).set("status", status);
    return this.http.get<response>(environment.url + "tasks", {params : params});
  }

  getTask(id){
    let params : HttpParams = new HttpParams().set("id", id);
    return this.http.get<response>(environment.url + "task", {params : params});
  }

  updateTask(id, task){
    return this.http.put<response>(environment.url + "task/"+id, task);
  }

  saveTask(task){
    return this.http.post<response>(environment.url + "task", task);
  }

  deleteTask(id){
    return this.http.delete<response>(environment.url + "task/"+id);
  }

}
